export default "__VITE_ASSET__673ab8ed__"